import React from 'react';
import Image from 'next/legacy/image';

import { getScaledImageHeight } from '../../../utils/getScaledImageHeight';
import { getImageData } from '../../../utils/contentful';

import {
  LogoContainer,
  PositionerBox,
  StyledGreenlightIcon,
  AffiliateLogo,
  VerticalDivider
} from './styles';

import { StyledGreenlightLogo } from '../../AffiliateHeader/styles';

import glLogoAbbr from '@/images/gl-logo-abbreviated.svg';
import verticalDivider from '@/images/vertical-divider.svg';
import { greenlightBrandingEnum } from '.';

interface AffiliateLogoGroupingTypes {
  affiliateLogo: any;
  useGreenlightIcon?: boolean | null;
  greenlightBranding?: greenlightBrandingEnum;
}

export function AffiliateLogoGrouping({
  affiliateLogo,
  useGreenlightIcon, //TODO: should be deprecated in follow-up ticket,
  greenlightBranding
}: AffiliateLogoGroupingTypes) {
  const { src, alt, width, height } = getImageData(affiliateLogo);

  const shouldUseGreenlightBranding = greenlightBranding !== undefined;
  const usingGreenlightIcon =
    useGreenlightIcon ||
    greenlightBranding === greenlightBrandingEnum.GREENLIGHT_ICON;

  const AFFILIATE_LOGO_MIN_HEIGHT_PX = 22;
  const AFFILIATE_LOGO_MAX_HEIGHT_PX = useGreenlightIcon ? 40 : 55;

  const logoWidth = width || 1;
  const logoHeight = height || 1;

  const { imageHeight } = getScaledImageHeight(
    logoWidth,
    logoHeight,
    AFFILIATE_LOGO_MIN_HEIGHT_PX,
    AFFILIATE_LOGO_MAX_HEIGHT_PX
  );

  const affiliateLogoHeight = `${parseInt(imageHeight) * 2}rem`;
  return (
    <LogoContainer useGreenlightIcon={usingGreenlightIcon}>
      <PositionerBox useGreenlightIcon={usingGreenlightIcon}>
        {shouldUseGreenlightBranding ? (
          // Render based on Greenlight branding
          greenlightBranding === greenlightBrandingEnum.GREENLIGHT_ICON ? (
            <StyledGreenlightIcon
              src={glLogoAbbr}
              alt="Greenlight abbreviated logo"
            />
          ) : greenlightBranding === greenlightBrandingEnum.GREENLIGHT_LOGO ? (
            <StyledGreenlightLogo isMenuOpen={false} />
          ) : null
        ) : // Fallback to useGreenlightIcon
        useGreenlightIcon ? (
          <StyledGreenlightIcon
            src={glLogoAbbr}
            alt="Greenlight abbreviated logo"
          />
        ) : (
          <StyledGreenlightLogo isMenuOpen={false} />
        )}
      </PositionerBox>
      {greenlightBranding !== greenlightBrandingEnum.NONE && (
        <VerticalDivider>
          <Image src={verticalDivider} alt="" />
        </VerticalDivider>
      )}
      <PositionerBox useGreenlightIcon={usingGreenlightIcon}>
        <AffiliateLogo
          src={src}
          logoHeight={
            usingGreenlightIcon ||
            greenlightBranding === greenlightBrandingEnum.NONE
              ? imageHeight
              : affiliateLogoHeight
          }
          alt={(alt ?? '') || 'Affiliate of Greenlight logo'}
        />
      </PositionerBox>
    </LogoContainer>
  );
}
